// src/components/CustomEvent.jsx
const CustomEvent = ({ event }) => {
    return (
      <div>
        <strong>{event.title}</strong>
        <div style={{ fontSize: "0.8em", color: "#666" }}>
          {event.user} - {event.DNI}
        </div>
      </div>
    );
  };
  
  export default CustomEvent;